import axios from 'axios'

export default {
  getPaymentInformation: (officeId) => axios.get(`/offices/${officeId}/transaction_data`),
  getIssuerBalance: (officeId) => axios.get(`/offices/${officeId}/issuer_balance`),
  getOfficeMovements: (page = 1) => axios.get(`/movements`, { params: { page: page } }),
  getTokenizedCards: (officeId) => axios.get(`/offices/${officeId}/tokenized_cards`),
  deleteTokenizedCard: (officeId, data) => axios.put(`/offices/${officeId}/remove_tokenized_cards`, data),
  redirectPayment: (officeId, data) => axios.put(`/offices/${officeId}/redirect_payment`, data),
  tokenizedPayment: (officeId, data) => axios.put(`/offices/${officeId}/tokenized_payment`, data),
  // Dashboard data
  getDashboardExpenses: (filters = {}) => {
    return axios.get('/dashboard/expenses', { params: { ...filters } })
},
  getPeopleDashboardInsight: (page = 1, itemsPerPage = 5) => axios.get('/dashboard/insight/people', { params: { page: page, itemsPerPage: itemsPerPage } }),
  getMileageDashboardInsight: (page = 1, itemsPerPage = 5, filters = {}) => axios.get('/dashboard/insight/mileage', { params: { page: page, itemsPerPage: itemsPerPage, ...filters } }),
  getBudgetsDashboardInsight: (page = 1, itemsPerPage = 5, filters = { 'status.code[]': 'ACTIVE', 'order[spent]': 'DESC' }) => axios.get('/dashboard/budgets', { params: { page: page, itemsPerPage: itemsPerPage, ...filters } })

}
